/**
 * Mobile Date/Time Picker Component
 * Mobile-optimized date and time pickers
 */

import React, { useState } from 'react';
import { useMobile } from '../contexts/MobileContext';
import { Calendar, Clock } from 'lucide-react';
import MobileBottomSheet from './MobileBottomSheet';

const MobileDateTimePicker = ({
  value,
  onChange,
  type = 'date',
  label,
  placeholder,
  min,
  max,
  className = '',
  ...props
}) => {
  const mobile = useMobile();
  const [isOpen, setIsOpen] = useState(false);
  const [localValue, setLocalValue] = useState(value || '');

  const formatDisplayValue = (val) => {
    if (!val) return placeholder || `Select ${type}`;
    
    if (type === 'date') {
      const date = new Date(val);
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    } else if (type === 'time') {
      const date = new Date(`2000-01-01T${val}`);
      return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    }
    return val;
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  if (!mobile.isMobile) {
    return (
      <div className={className}>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
        <input
          type={type}
          value={value}
          onChange={onChange}
          min={min}
          max={max}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg"
          {...props}
        />
      </div>
    );
  }

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-gray-300 mb-2">
          {label}
        </label>
      )}
      
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="w-full px-4 py-3 bg-gray-800 border-2 border-gray-700 rounded-xl text-white text-left flex items-center justify-between focus:border-purple-500 focus:outline-none"
        aria-label={label || `Select ${type}`}
      >
        <span className={localValue ? '' : 'text-gray-400'}>
          {formatDisplayValue(localValue)}
        </span>
        {type === 'date' ? (
          <Calendar className="w-5 h-5 text-gray-400" />
        ) : (
          <Clock className="w-5 h-5 text-gray-400" />
        )}
      </button>

      <MobileBottomSheet
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={`Select ${type === 'date' ? 'Date' : 'Time'}`}
      >
        <div className="space-y-4">
          <input
            type={type}
            value={localValue}
            onChange={handleChange}
            min={min}
            max={max}
            className="w-full px-4 py-3 bg-gray-800 border-2 border-gray-700 rounded-xl text-white text-center text-lg"
            style={{ fontSize: '1.25rem' }}
            {...props}
          />
          <button
            onClick={() => {
              setIsOpen(false);
              if (onChange && localValue) {
                onChange(localValue);
              }
            }}
            className="w-full px-4 py-3 bg-purple-600 text-white rounded-xl font-semibold"
          >
            Confirm
          </button>
        </div>
      </MobileBottomSheet>
    </div>
  );
};

export default MobileDateTimePicker;







